import { AxiosError, AxiosResponse } from 'axios';
import { ApiClient, ApiClientConfig } from 'Foundation/Api';
import { config } from '../../../../config';

const applicableRatesUrl: string = config.claimApi.urls.applicableRates;
const applicableRatesUpdateUrl: string = config.claimApi.urls.applicableUdateRates;
const apiClientConfig: ApiClientConfig = { timeout: config.claimApi.requestTimeout };

const errorCatch = (err: any) => {
  return err;
};

export const getApplicableRates = async (authContext: any, provinceId: number) => {
  const applicableRatesRequestUrl = `${applicableRatesUrl}/${provinceId}`;
  return ApiClient(authContext, apiClientConfig)
    .getWithAuth(applicableRatesRequestUrl)
    .then((res: AxiosResponse<any>) => res.data)
    .catch((err: AxiosError) => {
      errorCatch(err);
      Promise.reject(err);
    });
};

export const updateApplicableRates = async (
  authContext: any,
  formPayload: any
): Promise<AxiosResponse<any> | undefined> => {
  try {
    const updatedRecord: AxiosResponse<any> = await ApiClient(
      authContext,
      apiClientConfig
    ).putWithAuth(applicableRatesUpdateUrl, formPayload);
    return updatedRecord;
  } catch (err) {
    errorCatch(err);
  }
};
